<app-page-wrapper>
    <span class="link breadcrumb-link" (click)="goBack()">
      <i class="far fa-angle-left"></i> Back
    </span>
    <div class="mt-2"></div>
    <app-onboarding-banner [bannerText]="'Clever rostering'"></app-onboarding-banner>
    <div class="mt-1"></div>
    <div class="row mt-4">
        <div class="col-6">
            <div class="padding">
                <div class="header">Set up your Clever connection</div>
                <ul class="mb-4">
                    <li>
                        Log in to your Clever dashboard by clicking the button below.
                    </li>
                    <li *ngIf="!onboardingStatus || !onboardingStatus.ImplementationScope">
                        Establish the sharing rules for Joy School English.
                    </li>
                    <li *ngIf="onboardingStatus && onboardingStatus.ImplementationScope">
                        Establish the sharing rules for Joy School English:
                        <br>
                        {{ onboardingStatus.ImplementationScope }}
                    </li>
                    <li>
                        When complete, enter your Clever district ID in the field to the right and click Submit.
                    </li>
                </ul>
                <a href="https://schools.clever.com/applications/add/joyschool-kinder" target="_blank" rel="noreferrer noopener">
                    <button class="btn btn-primary wide-button">Go to Clever</button>
                </a>
            </div>
        </div>
        <div class="col-6">
            <div class="padding">
                <div class="header">Enter your Clever district ID</div>
                <div class="mb-4">found in your Clever profile.</div>
                <div class="row">
                    <div class="col-9">
                        <input [(ngModel)]="cleverId" class="form-control" placeholder="Enter Clever ID">
                    </div>
                    <div class="col-3">
                        <button *ngIf="!waiting" (click)="submitCleverId()" class="btn btn-primary">Submit</button>
                        <app-loading-spinner *ngIf="waiting" text="" noMargin="true"></app-loading-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4 mb-3 header">
        Need help finding your district Clever ID?
    </div>
    <ol>
        <li>Log in to your Clever account.</li>
        <li>Go to your dashboard and click on your name in the upper-right corner of the screen, then select Profile.</li>
        <li>Look for your district ID under your account information.</li>
        <li>Copy your district ID, then enter it in the field on this page and click Submit.</li>
    </ol>
</app-page-wrapper>